import { randomUUID } from "crypto"
import SpatialBoundary, { CardinalDirection, RNum } from "./MapGrid"

export interface InventoryLocationPosition {
  id: string,
  moving?: boolean,
  editing?: boolean,
  position: {
    bounds: [
      { x: number, y: number, z: number },
      { x: number, y: number, z: number }
    ],
    direction: CardinalDirection
  }
}

class LocationController {
  private _locations: Array<InventoryLocationPosition>

  constructor(context: WarehouseMap) {
    this._locations = []
  }

  add (location: InventoryLocationPosition) {
    // add entity
  }

  update (location: string, data: InventoryLocationPosition) {
    // update entity
  }

  remove (location: string) {
    // remove entity
  }

  find (location: string | { x: number, y: number, z: number }) {
    if (typeof location === 'string') {
      // direct lookup by id
      return
    }

    // find entity intersection for region/point

  }

}

export default class WarehouseMap {
  private _grid: SpatialBoundary

  private _location_controller: LocationController

  constructor(x: number, y: number, z = 0) {
    if (!x || x < 0 || !y || y < 0 || z < 0)
      throw Error('Invalid warehouse map bounds')

    this._grid = new SpatialBoundary(x, y, z)
    this._location_controller = new LocationController(this)
  }

  get grid () {
    return this._grid
  }

  // returns a "2D grid" slice at "z"
  Zgrid (z = 0) {
    return this._grid.points.slice('z', z)
  }

  get location () {
    return this._location_controller
  }

  // (re-)populate with currently set location list in location-controller
  populate () {
    // TODO:
  }
}
